import { DetailTabModel } from '@y42/feature/detail-view';
import { exportTriggerIcon } from '@y42/feature/icons';

export const ExportTabs: DetailTabModel[] = [
  {
    path: 'overview',
    logo: exportTriggerIcon,
    label: 'Trigger setup',
    description: 'Edit the triggers of this export',
  },
];
